import Model, { attr, belongsTo } from "@ember-data/model";
import { task } from "ember-concurrency";
import type Database from "glesys-controlpanel/models/database";
import type { Type } from "@warp-drive/core-types/symbols";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export interface InstanceUserPermission {
  databaseid: string;
  name: string;
  permission: "READ" | "WRITE";
}

export default class InstanceUserModel extends Model {
  @attr declare username: string;
  @attr declare permissions: InstanceUserPermission[];

  @belongsTo<Database>("database", { async: false, inverse: "instanceUsers" }) declare database: Database;

  deleteTask = task(async () => {
    try {
      this.deleteRecord();
      await this.store.request(saveRecord(this));
    } catch (error) {
      this.rollbackAttributes();
      throw error;
    }
  });

  declare [Type]: "instance-user";
}
